import { render, staticRenderFns } from "./AddonInformationSummary.vue?vue&type=template&id=d700d210&scoped=true"
import script from "./AddonInformationSummary.vue?vue&type=script&lang=js"
export * from "./AddonInformationSummary.vue?vue&type=script&lang=js"
import style0 from "./AddonInformationSummary.vue?vue&type=style&index=0&id=d700d210&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d700d210",
  null
  
)

export default component.exports